import React, { Component, Fragment } from 'react';
import PageHeader from '@app/components/Layout/PageHeader';

class DashBoard extends Component {
    render() {
        return (
            <Fragment>
                <PageHeader pageTitle="dashboard" />
            </Fragment>
        );
    }
}

export default DashBoard;
